// extracted by mini-css-extract-plugin
export default {"aeroLogo":"ProtectedRoutes_aeroLogo__Te2GN","navbar":"ProtectedRoutes_navbar__kKc0m"};